var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('h3',[_vm._v("CMS Configuration")])]),_c('admin-cms-credentials-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }